/*
 * MORBÌ™ — Pulizia automatica omaggi
 * Rimuove Spedizione, Ebook e Biberon quando
 * l'ultimo Morbì™ esce dal carrello.
 */

(function () {
  "use strict";

  const MORBI_PRODUCT_ID = 16044791562570;

  const GIFT_VARIANT_IDS = new Set([
    63677319086410, // Spedizione
    63677352935754, // Ebook digitale
    63707214315850  // Biberon 60 ml
  ]);

  let checking = false;
  let pending = false;
  let lastCheck = 0;

  async function checkMorbiGifts() {
    if (checking) {
      pending = true;
      return;
    }

    checking = true;

    try {
      const response = await fetch(
        window.Shopify?.routes?.root
          ? window.Shopify.routes.root + "cart.js"
          : "/cart.js",
        { credentials: "same-origin", cache: "no-store" }
      );

      if (!response.ok) return;

      const cart = await response.json();

      const hasMorbi = cart.items.some(
        item =>
          Number(item.product_id) === MORBI_PRODUCT_ID &&
          item.quantity > 0
      );

      if (hasMorbi) return;

      const gifts = cart.items.filter(
        item =>
          GIFT_VARIANT_IDS.has(Number(item.variant_id))
      );

      if (!gifts.length) return;

      const updates = {};

      for (const gift of gifts) {
        updates[gift.key] = 0;
      }

      const updateResponse = await fetch(
        window.Shopify?.routes?.root
          ? window.Shopify.routes.root + "cart/update.js"
          : "/cart/update.js",
        {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ updates })
        }
      );

      if (!updateResponse.ok) {
        throw new Error("Errore rimozione omaggi");
      }

      document.dispatchEvent(
        new CustomEvent("cart:refresh")
      );

      window.dispatchEvent(
        new CustomEvent("cart:refresh")
      );

    } catch (error) {
      console.error(
        "[Morbì] Pulizia omaggi:",
        error
      );
    } finally {
      checking = false;

      if (pending) {
        pending = false;
        setTimeout(checkMorbiGifts, 300);
      }
    }
  }

  function scheduleCheck() {
    const now = Date.now();

    if (now - lastCheck < 250) return;

    lastCheck = now;
    setTimeout(checkMorbiGifts, 450);
  }

  // Controlla quando cambia il carrello.
  document.addEventListener(
    "cart:change",
    scheduleCheck
  );

  document.addEventListener(
    "cart:updated",
    scheduleCheck
  );

  document.addEventListener(
    "cart:refresh",
    scheduleCheck
  );

  // Controlla anche le richieste AJAX
  // effettuate dalle app del carrello.
  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const response = await originalFetch.apply(
      this,
      args
    );

    const requestUrl =
      typeof args[0] === "string"
        ? args[0]
        : args[0]?.url || "";

    if (
      /\/cart\/(change|update|add|clear)\.js/.test(
        requestUrl
      )
    ) {
      scheduleCheck();
    }

    return response;
  };

  // Controllo iniziale.
  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      scheduleCheck
    );
  } else {
    scheduleCheck();
  }
})();